import API from "@/Services/API";

let config: any;

export default {
  getAllZonas() {
    return API.get("Zona/GetAllZonas");
  },
  getZonaById(id: number) {
    //return API().get("Zona/GetZonaByID/" + id);
    return API.get("Zona/GetZonaByID/" + id);
  },
  async createZonas(zonas)
    {
        return await API.post("Zona/CreateZonas", zonas);
    },
};
